import { useState } from "react";
import { useFormContext } from "react-hook-form";

import Box from "ds/components/Box";
import FormField from "ds/components/Form/Field";
import Tab from "ds/components/Tab";
import TabPanel from "ds/components/TabPanel";

import FormFileContentField from "./FileContentField";
import FormFileUploadField from "./FileUploadField";

export enum FileUploadEditorTabsValues {
  Upload = "Upload",
  AddManually = "Add manually",
}

type FileUploadEditorTabsProps = {
  uploadName: string;
  contentName: string;
  initialTab?: FileUploadEditorTabsValues;
  fullHeight?: boolean;
  exceedsFileSize?: boolean;
};

const FormFileUploadEditorTabs = ({
  uploadName,
  contentName,
  initialTab = FileUploadEditorTabsValues.Upload,
  fullHeight = false,
  exceedsFileSize,
}: FileUploadEditorTabsProps) => {
  const [currentTab, setCurrentTab] = useState(initialTab);
  const { watch } = useFormContext();

  const isUploadTab = currentTab === FileUploadEditorTabsValues.Upload;
  const isManuallyAddTab = currentTab === FileUploadEditorTabsValues.AddManually;
  const content = watch(contentName);

  return (
    <FormField label="File content" noMargin fullWidth fullHeight={fullHeight}>
      <Box direction="column" gap="medium" fullWidth fullHeight>
        <Box direction="row" gap="medium" fullWidth role="tablist">
          <Tab
            onClick={setCurrentTab}
            isActive={isUploadTab}
            id={FileUploadEditorTabsValues.Upload}
            label="Upload"
          />
          <Tab
            onClick={setCurrentTab}
            isActive={isManuallyAddTab}
            id={FileUploadEditorTabsValues.AddManually}
            label="Add manually"
          />
        </Box>

        <TabPanel isActive={isUploadTab} id={FileUploadEditorTabsValues.Upload} fullHeight>
          <FormFileUploadField name={uploadName} required={!content} />
        </TabPanel>
        <TabPanel
          isActive={isManuallyAddTab}
          id={FileUploadEditorTabsValues.AddManually}
          fullHeight
        >
          <FormFileContentField exceedsFileSize={exceedsFileSize} name={contentName} />
        </TabPanel>
      </Box>
    </FormField>
  );
};

export default FormFileUploadEditorTabs;
